import { createSlice } from "@reduxjs/toolkit";

import { updateOnboardingCompletionStatus } from "../../../helperFunctions";
import { removeCookie } from "../../../helperFunctions/cookies";
import { CLIENT_COOKIE_KEY } from "../../../utils/constants";
import { OnboardingCompletion } from "../../../utils/types";
import { ProfileType, SingleUser } from "./auth.type";

const initialState: {
  fetchingProfile: boolean;
  profile?: SingleUser & {
    type: ProfileType;
  };
  onboardingCompletionStatus?: OnboardingCompletion;
  isLoggedIn: boolean;
  approvalCount: number;
  isOfficial: boolean;
} = {
  fetchingProfile: false,
  profile: undefined,
  onboardingCompletionStatus: undefined,
  isLoggedIn: false,
  approvalCount: 0,
  isOfficial: false,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    profile_updated: (state, action) => {
      const updated_profile = { ...action.payload };

      state.profile = updated_profile;

      state.onboardingCompletionStatus =
        updateOnboardingCompletionStatus(updated_profile);
    },

    login: (state) => {
      state.isLoggedIn = true;
    },

    reset: (state) => {
      state = initialState;
    },

    logout: (state) => {
      removeCookie(CLIENT_COOKIE_KEY);
      localStorage.clear();

      return initialState;
    },

    approvalCountUpdated: (state, action) => {
      state.approvalCount = action.payload;
    },

    officialStatustUpdated: (state, action) => {
      state.isOfficial = action.payload;
    },
  },
});

export const AuthSliceReducer = AuthSlice.reducer;
export const AuthSliceActions = AuthSlice.actions;
